import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { MoreInfoComponent } from '../more-info/more-info.component';
import { InstructionComponent } from '../instruction/instruction.component';
import { HttpService } from '../../../services/http/http.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PlatformLocation, JsonPipe } from '@angular/common';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { Router } from '@angular/router';
import { UtilityServicesService } from 'src/app/services/utility-service/utility-services.service';
import { ErrorHandlerService } from 'src/app/services/errorHandler/error-handler.service';
import { jsonpCallbackContext } from '@angular/common/http/src/module';

@Component({
  selector: 'app-mcq-dashboard',
  templateUrl: './mcq-dashboard.component.html',
  styleUrls: ['./mcq-dashboard.component.scss']
})
export class McqDashboardComponent implements OnInit {
  timetest: any;
  actualExamTime: any = 600;
  timeLeft: any = 600;
  interval;
  time = "00:00";
  questionList = [];
  currentIndex = 0;
  //backPressed = false;
  totalTime = "00";
  elapsesTime;
  startTime;
  stopTime;
  showError = false;
  errorMsg = "";
  startTestTime;
  stopTestTime;
  isRefreshClicked = false;
  isOpenDialog = false;
  percentage: any = 0;
  score: string;
  resultTemplateUrl: any;
  maxAttemptCount: any;
  screenWidth: any;
  check: any;
  codingClubData: any;
  isUserPresentInCodinClub = true;
  constructor(public dialog: MatDialog,
    private router: Router,
    private httpService: HttpService,
    private spinnerService: Ng4LoadingSpinnerService,
    private snackbar: MatSnackBar,
    location1: PlatformLocation,
    private localstorageService: LocalstorageService,
    private utilityServices: UtilityServicesService,
    private errorService:ErrorHandlerService,
  ) {


    clearInterval(this.interval)
    location1.onPopState(() => {
      window.history.go(1);

      return false;

    });




  }



  ngOnInit() {


    this.screenWidth = window.innerWidth;
    this.getAllQuestions();
   
    var redirectToRegister = localStorage.getItem('redirectToRegister');
    this.campaignId = localStorage.getItem('campaignId');
    if (redirectToRegister == '1') {
      localStorage.setItem('redirectToRegister', '0');
  
    } else {
      this.campaignId = localStorage.getItem('campaignId');
     
      history.pushState(null, null, location.href);

     
      var examStarted = this.localstorageService.getData("examStarted");
     


      if (examStarted != null && examStarted != undefined && examStarted == "1") {
        
        this.currentIndex = this.localstorageService.getData("currentIndex");
       
      }
      else {


        // setTimeout(() => {
        //   // console.log('on load! : ',this.backPressed);
        //   // if(!this.backPressed){



        //   // }
        // }, 500);
      }
    }

  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {


    this.screenWidth = window.innerWidth;


  }
  campaignId;
  @HostListener('window:beforeunload', ['$event']) beforeUnload($event) {
  
    this.isRefreshClicked = true;
    event.preventDefault();
    $event.returnValue = 'Your data will be lost!';
    $event.returnValue = true;

    return "Your data will be lost!"
  }
  @HostListener('window:unload', ['$event']) onUnload($event) {
  
    var campaignId1 = localStorage.getItem('campaignId')
    localStorage.setItem('redirectToRegister', '1');
  
    return false
  }

  openInstructionDialog() {
   
    const dialogInstructionRef = this.dialog.open(InstructionComponent, {
      data: {
    
        "totalTime": this.timetest

      },

      disableClose: true


    }

    );

    dialogInstructionRef.afterClosed().subscribe(result => {

      this.startTimer();
      this.startTimerApi();
      this.startTime = this.getCurrentTime();
      this.startTestTime = this.getCurrentTime();
      this.localstorageService.setData("examStarted", "1");
      this.localstorageService.setData("startTestTime", this.startTestTime);

    });
  }


  startTimerApi() {
    var contentBody = {
      url: "/users/questionset/starttime",
      body: {}
    }
    this.httpService.httpPostWithTokens(contentBody, true).subscribe(response => {
 
    }, error => {
    })
  }
  submitTest() {
    if(localStorage.getItem('checkValue') != 'true')
    {
      this.checkUserPersentInCodinClub();
    }
    if (this.timeLeft > 0) {
      this.confirmDialog();
    }
    else {
      this.submitTestApi();
    }
  }  
  submitTestApi() {
    if (this.currentIndex != -1) {
      this.stopTime = this.getCurrentTime();
      this.questionList[this.currentIndex]["timeTaken"] += this.elapsedTime(this.startTime, this.stopTime);
    
    }

    //calling coding club api for check user information
    var email = localStorage.getItem('email');
 
    var userId = this.localstorageService.getData("userId");
    var contentBody = { url: "/users/answers", body: { "solvedAnswers": this.questionList } }
    this.utilityServices.showSpinner();

    this.httpService.httpPostWithTokens(contentBody, true).subscribe(response => {
      JSON.stringify(response)
      localStorage.setItem('resultResponse',JSON.stringify((response as any).data.codinClubTopicWiseMarks))
      localStorage.setItem('date',(response as any).data.currentDate)
      localStorage.setItem('marksObtained',(response as any).data.marksObtained )
      localStorage.setItem('perCentage',(response as any).data.percentage )
      localStorage.setItem('overallProfeciency',(response as any).data.overallProfeciency)
    
  

      localStorage.setItem('isDataToBeStoredInCodingCafe', (response as any).data.additionalInformation)

      this.utilityServices.hideSpinner();
      this.resultTemplateUrl = (response as any).data.resultTemplateUrl
     // console.log(this.resultTemplateUrl+"template url")
      localStorage.setItem('testStatus', (response as any).data.testStatus)
      localStorage.setItem('user', (response as any).data.userName)
      this.percentage = (((response as any).data.marksObtained * 100) / (response as any).data.totalMarks)
      
      localStorage.setItem('percent', this.percentage)
      this.score = (response as any).data.marksObtained + "/" + (response as any).data.totalMarks
    

      localStorage.setItem("result", this.score)

      localStorage.setItem('Response', JSON.stringify(response));
    
      var currentPinCode = this.localstorageService.getData("location");
    
      clearInterval(this.interval);

     
      if ((response as any).data.additionalInformation === true &&
        localStorage.getItem('isDataToBeStoredInCodingClub') == 'true' ||
        (response as any).data.additionalInformation === true &&
        localStorage.getItem('checkValue') == 'true' ) {
        this.openMoreInfoDialog();

      } else if ((response as any).data.additionalInformation === true &&
        localStorage.getItem('isDataToBeStoredInCodingClub') == 'false' ||
        (response as any).data.additionalInformation === false &&
        localStorage.getItem('isDataToBeStoredInCodingClub') == 'true') {
        this.updateUserDetails(this.codingClubData);

      } else if(this.resultTemplateUrl == "ETResultTemplate"){
        this.httpService.redirectTo("/etresult");
       }
       else{
        this.httpService.redirectTo("/ccresult");
       }
      

    }, error => {
      this.utilityServices.hideSpinner();
      this.spinnerService.hide();
      if(error !=null){
        this.errorService.handleError(error)
      }
      else if(error.error.code = -4) {
        clearInterval(this.interval);
      }
      this.openSnackBar(error.error.message);
    })
  }

  checkUserPersentInCodinClub() {
    this.utilityServices.getCodingClubUserInfo(this.localstorageService.getData('email'))
      .subscribe(response => {
        this.codingClubData = (response as any).data;
        if ((response as any).data != null) {
          this.localstorageService.setData('isDataToBeStoredInCodingClub', false)
        } else {
          this.localstorageService.setData('isDataToBeStoredInCodingClub', true)
        }
      }, error => {
        this.localstorageService.setData('isDataToBeStoredInCodingClub', true)
      });
  }

  confirmDialog() {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: { "discription": "Are you sure want to submit the test?" },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if (result == true) {
        this.submitTestApi();
      }

    });
  }

  openMoreInfoDialog() {
    this.isOpenDialog = true;
    const dialogRef = this.dialog.open(MoreInfoComponent, {
      width: '650px',
      panelClass: 'moreinfo-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(this.resultTemplateUrl)
      this.isOpenDialog = false;
      if (result) {
       if(this.resultTemplateUrl == "ETResultTemplate"){
        this.httpService.redirectTo("/etresult");
       }
       else{
        this.httpService.redirectTo("/ccresult");
       }
       
      }
    });
  }

  secondsToString(seconds) {
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    if (numseconds > 9) {
      if (numminutes > 9) {
        return numminutes + ":" + numseconds;
      }
      else {
        return "0" + numminutes + ":" + numseconds;
      }
    }
    else {
      if (numminutes > 9) {
        return numminutes + ":" + "0" + numseconds;
      }
      else {
        return "0" + numminutes + ":" + "0" + numseconds;
      }
    }

  }

  startTimer() {
    this.interval = setInterval(() => {
    

      if (this.timeLeft < 0) {
        this.timeLeft = 0;
      }
      if (this.timeLeft > 0) {
        // console.log("i am in 2");
        this.timeLeft--;
        this.time = this.secondsToString(this.timeLeft)
        if (this.time == "01:00") {
          if (this.isOpenDialog == false) {
            this.openSnackBar("Only 1 minute is Remaining");
          }
        }
      }
      else if (this.timeLeft == 0) {
        // console.log("i am in 3");
        clearInterval(this.interval);
        this.timeLeft--;
        this.time = "00:00";
        try {
          this.dialog.closeAll();
        }
        catch (e) { }
        this.submitTestApi();
       
      }
    }, 1000)
  }
  onRightClick(event) {
    
    return false;
  }
  submitSingleAnswer(data) {
   
    var data1 = {
      answers: data.answers,
      questionId: data.questionId,
      seen: data.seen,
      timeTaken: '' + data.timeTaken
    }
   

    this.spinnerService.show();
    var contentBody = { url: "/users/answer", body: data1 }
    this.httpService.httpPostWithTokens(contentBody, true).subscribe(response => {
      //console.log("success ", response);
      this.spinnerService.hide();
    }, error => {
      //console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  selectQuestion(index) {
    if (this.currentIndex != -1) {
      this.stopTime = this.getCurrentTime();
      this.questionList[this.currentIndex]["timeTaken"] = parseFloat(this.questionList[this.currentIndex]["timeTaken"]) + this.elapsedTime(this.startTime, this.stopTime);
    }
    //console.log(this.questionList[this.currentIndex]);

    var data = {
      timeTaken: this.questionList[this.currentIndex]["timeTaken"],
      answers: this.questionList[this.currentIndex]["givenAnswers"],
      seen: this.questionList[this.currentIndex].seen,
      questionId: this.questionList[this.currentIndex].questionId
    }
    this.submitSingleAnswer(data)
    this.currentIndex = index;
    this.questionList[this.currentIndex]["seen"] = "1";
    this.startTime = this.getCurrentTime();
    this.setLocatstorageData();
  }

  setLocatstorageData() {
    this.localstorageService.setData("questionSet", JSON.stringify(this.questionList));
    this.localstorageService.setData("currentIndex", this.currentIndex);
  }

  openSnackBar(message: string) {
    if (message === null) {
      this.snackbar.open("Network Error", null, {
        duration: 5000
      });
    }
    else {
      this.snackbar.open(message, null, {
        duration: 5000
      });
    }
  }

  nextBtnClick() {
    window.scrollTo(0,0);
    if (this.currentIndex != -1) {
      this.stopTime = this.getCurrentTime();
      // console.log(this.questionList[this.currentIndex]["timeTaken"])
      this.questionList[this.currentIndex]["timeTaken"] = parseFloat(this.questionList[this.currentIndex]["timeTaken"]) + this.elapsedTime(this.startTime, this.stopTime);
      //console.log(this.questionList[this.currentIndex])
    }
    //console.log(this.questionList[this.currentIndex]);

    // mcq api
    var data = {
      timeTaken: this.questionList[this.currentIndex]["timeTaken"],// / 1000,
      answers: this.questionList[this.currentIndex]["givenAnswers"],
      seen: this.questionList[this.currentIndex].seen,
      questionId: this.questionList[this.currentIndex].questionId
    }
    this.submitSingleAnswer(data);
    this.currentIndex = this.currentIndex + 1;
    this.questionList[this.currentIndex]["seen"] = "1";
    this.startTime = this.getCurrentTime();
    this.setLocatstorageData();
  }
  previousBtnClick() {
    window.scrollTo(0,0);
    if (this.currentIndex != -1) {
      this.stopTime = this.getCurrentTime();
      this.questionList[this.currentIndex]["timeTaken"] = parseFloat(this.questionList[this.currentIndex]["timeTaken"]) + this.elapsedTime(this.startTime, this.stopTime);
      //console.log(this.questionList)
    }
    var data = {
      timeTaken: this.questionList[this.currentIndex]["timeTaken"],// / 1000,
      answers: this.questionList[this.currentIndex]["givenAnswers"],
      seen: this.questionList[this.currentIndex].seen,
      questionId: this.questionList[this.currentIndex].questionId
    }
    this.submitSingleAnswer(data);
    this.currentIndex = this.currentIndex - 1;
    this.questionList[this.currentIndex]["seen"] = "1";
    this.startTime = this.getCurrentTime();
    this.setLocatstorageData();
  }
  optionCheckBoxChange(e, optVal, index) {
    // console.log(e)
    // console.log(optVal)
    // console.log(this.questionList[index])

    if (e.checked) {
      if (this.questionList[index].givenAnswers.indexOf(optVal) > -1) {
        this.questionList[index].givenAnswers.splice(this.questionList[index].givenAnswers.indexOf(optVal), 1);
      }
      else {
        this.questionList[index].givenAnswers.push(optVal);
      }
    }
    else {
      if (this.questionList[index].givenAnswers.indexOf(optVal) > -1) {
        this.questionList[index].givenAnswers.splice(this.questionList[index].givenAnswers.indexOf(optVal), 1);
      }
    }
    //console.log(this.questionList[index])
  }

  optionRadioButtonChange(e, optVal, index) {
    //console.log(e);

    if (this.questionList[index].givenAnswers.length > 0) {
      this.questionList[index].givenAnswers = [];
    }
    // else {
    //   this.questionList[index].answers.push(optVal);
    // }
    this.questionList[index].givenAnswers.push(optVal);
  }

  getCurrentTime() {
    var d = new Date();
    var n = d.getTime();
    return n;
  }

  elapsedTime(start, stop) {
    // this.elapsesTime = (stop - start)/1000;
    // console.log("elapsesTime",this.elapsesTime);
    return stop - start;
  }

  updateUserDetails(userDetails: any) {
    console.log("User Details in update user--->",userDetails);
    
    var data;
    if (userDetails !== null && userDetails !== undefined && userDetails !== '') {
      data = {
        graduationYear: userDetails.yearOfPassing,
        dataToBeStoredInCodinClub: localStorage.getItem('isDataToBeStoredInCodingClub'),
        dataToBeStoredInCodingCafe: localStorage.getItem('isDataToBeStoredInCodingCafe')
      }
    } else {
      data = {
        dataToBeStoredInCodinClub: localStorage.getItem('isDataToBeStoredInCodingClub'),
        dataToBeStoredInCodingCafe: localStorage.getItem('isDataToBeStoredInCodingCafe')
      }
    }

    //console.log(data + "flag");

    let userId = this.localstorageService.getData('userId');
    this.spinnerService.show();
    var contentBody = { url: "/mcq/users/updateinformation", body: data }
   // console.log('Body:', contentBody);

    this.httpService.putWithTokens(contentBody, true).subscribe(response => {
     
      this.spinnerService.hide();
      if(this.resultTemplateUrl == "ETResultTemplate"){
        this.httpService.redirectTo("/etresult");
       }
       else{
        this.httpService.redirectTo("/ccresult");
       }


    }, error => {
      // console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }


  getAllQuestions() {
   // this.spinnerService.hide()
    //console.log("Get All Questions");
    this.check = localStorage.getItem('checkValue');
   // console.log("checkValue", this.check);
    var userId = this.localstorageService.getData("userId");
   // this.spinnerService.show();
    var contentBody = { url: "/users/questionset", body: {} }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
    
      this.timetest = (response as any).data.test.testTime;
     


      this.maxAttemptCount = (response as any).data.maxAttemptCount;
      
      localStorage.setItem('testTokens', (response as any).data.token);

      if (response !== null && response !== undefined && (response as any).data.test.userQuestionSets.length > 0) {
        this.questionList = (response as any).data.test.userQuestionSets;
        if (response["lastQuestionId"] != null && response["lastQuestionId"] != "") {
          for (let i = 0; i < this.questionList.length; i++) {
            if (this.questionList[i].questionId === response["lastQuestionId"]) {
             // console.log("index of question", i);

              this.currentIndex = i;
              this.setLocatstorageData();
            }
          }
        }
        this.timeLeft = parseInt((response as any).data.test.testTime) * 60;
        

        this.totalTime = this.secondsToString(parseInt((response as any).data.test.testTime) * 60);
        //this.localstorageService.setData("actualExamTime", parseInt(response["testTime"]));
        //console.log("questionList ", this.questionList);
        for (let i = 0; i < this.questionList.length; i++) {
          if (i == 0) {
            this.questionList[i]["seen"] = "1";
          }
          else {
            this.questionList[i]["seen"] = "0";
          }
          if (this.questionList[i]["timeTaken"] == null || this.questionList[i]["timeTaken"] == undefined) {
            this.questionList[i]["timeTaken"] = 0;
          }
          this.questionList[i]["answers"] = [];
          if (this.questionList[i]["optionType"] == 'CB') {
            for (let j = 0; j < this.questionList[i]["options"].length; j++) {
              this.questionList[i]["options"][j]["selected"] = false;
              for (let k = 0; k < this.questionList[i]["givenAnswers"].length; k++) {
                if (this.questionList[i]["options"][j]["id"] == this.questionList[i]["givenAnswers"][k]) {
                  this.questionList[i]["options"][j]["selected"] = true;
                }
              }
            }
          }
        }
        //this.totalTime = response["testTime"];
        if (this.totalTime === undefined) {
          this.totalTime = "00";
        }
        this.startTimerApi();
        this.currentIndex = 0;
        // this.localstorageService.setData("questionSet",JSON.stringify(this.questionList));
        // this.localstorageService.setData("currentIndex",this.currentIndex);
        this.setLocatstorageData();
        if (localStorage.getItem('checkValue') == 'true') {
          this.startTimer();
          this.startTimerApi();
          this.startTime = this.getCurrentTime();
          this.startTestTime = this.getCurrentTime();
          this.localstorageService.setData("examStarted", "1");
          this.localstorageService.setData("startTestTime", this.startTestTime);
        } else {
          if (localStorage.getItem('fromUrl') == null) {
            this.openInstructionDialog();
          } else {
            this.startTimer();
            this.startTimerApi();
            this.startTime = this.getCurrentTime();
            this.startTestTime = this.getCurrentTime();
            this.localstorageService.setData("examStarted", "1");
            this.localstorageService.setData("startTestTime", this.startTestTime);
          }
        }
      }
      else {
        this.spinnerService.hide();
        //console.log("Error");
        this.showError = true;
        this.openSnackBar("Question error came");
      }
      this.spinnerService.hide();
      //console.log("stop ")
    }, error => {
      //   localStorage.clear();
      //console.log("error ", error);
      this.spinnerService.hide();
      //   localStorage.clear();
      // if(error.error.code==-4){
      this.showError = true;
      this.errorMsg = error.error.message;
      //console.log("Error Message",this.errorMsg);
      // }
      this.openSnackBar(error.error.message);
      //this.router.navigate['not-found'];

    })
  }


  goToLink() {
    const link = 'https://economictimes.indiatimes.com/engage/campusstarcontact5.cms';
    window.open(link, '_blank');
  }
}